(function () {
  var PRODUCT_SECTION_CLASS = 'shopify-section--main-product';
  var GALLERY_SELECTOR = '.product-gallery';
  var IS_PDP = !!document.querySelector('.' + PRODUCT_SECTION_CLASS);

  // One shared cache for both PDP + cards
  var productCache = Object.create(null);

  /* ===================== Shared helpers ===================== */
  function fetchProduct(handle, signal) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) productCache[handle] = j; return j; });
  }

  /* --- Card image sizing -----------------------------------------------
     product.images URLs are the untouched originals (this catalog runs up to
     3288x4110). A decoded bitmap costs width x height x 4 bytes regardless of
     how well the JPEG compresses, so one of those is ~54 MB resident for a
     slot that renders around 180px wide. Warm the sized candidate the card
     would actually request, never the original. WARM_CAP covers 74vw at 3x DPR
     on mobile and the 3-up desktop grid at 2x. */
  var WARM_CAP = 1000;
  var CARD_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000];

  function atWidth(url, w) {
    if (!url) return '';
    var q = url.indexOf('?');
    var base = q === -1 ? url : url.slice(0, q);
    var keep = (q === -1 ? '' : url.slice(q + 1)).split('&').filter(function (kv) {
      return kv && !/^(width|height|crop)=/.test(kv);
    });
    keep.push('width=' + w);
    return base + '?' + keep.join('&');
  }

  function cardSrcset(url) {
    return CARD_WIDTHS.map(function (w) { return atWidth(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  // Reuse the card's own rendered sizes attribute so a warmed candidate is the
  // same one the render resolves to — otherwise the warm is a second download.
  function cardSizes(cardEl) {
    var im = cardEl && cardEl.querySelector('[data-gallery-track] img, img.product-card__image--primary');
    return (im && im.getAttribute('sizes')) || '';
  }

  // Assign sizes/srcset BEFORE src, or the browser commits to src first.
  function applyCardSrc(img, url, sizesAttr) {
    if (sizesAttr) {
      img.sizes = sizesAttr;
      img.srcset = cardSrcset(url);
    } else {
      img.removeAttribute('srcset');
    }
    img.src = atWidth(url, WARM_CAP);
  }

  // No img.decode() here. decode() forces the full bitmap resident, which is
  // what took iOS tabs down on cards carrying a lot of colorways.
  function preload(url, sizesAttr) {
    if (!url) return Promise.resolve();
    var img = new Image();
    img.decoding = 'async';
    applyCardSrc(img, url, sizesAttr);
    return new Promise(function (resolve) { img.onload = img.onerror = resolve; });
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  /* ===================== PDP (AJAX) ===================== */
  if (IS_PDP) {
    var pv = {}; // PDP-only helpers

    pv.getMainSectionEl = function(){ return document.querySelector('.' + PRODUCT_SECTION_CLASS); };
    pv.getMainSectionId = function(){ var el = pv.getMainSectionEl(); return el ? el.id.replace(/^shopify-section-/,'') : null; };
    pv.getWrapperSectionIdFor = function(el){ var s = el && el.closest('.shopify-section'); return s ? s.id.replace(/^shopify-section-/,'') : null; };
    pv.urlWithSections = function(url, ids){ var u = new URL(url, window.location.origin); u.searchParams.set('sections', ids.join(',')); return u.toString(); };

    pv.setLoading = function(on){
      var secs = [];
      var main = pv.getMainSectionEl(); if (main) secs.push(main);
      document.querySelectorAll('[data-product-refresh-full]').forEach(function(n){ var s=n.closest('.shopify-section'); if (s) secs.push(s); });
      document.querySelectorAll('[data-product-refresh-images]').forEach(function(n){ var s=n.closest('.shopify-section'); if (s) secs.push(s); });
      secs.forEach(function(sec){ sec.classList.toggle('is-loading', !!on); sec.setAttribute('aria-busy', on ? 'true':'false'); });
    };

    pv.getVariantPicker = function(){ var sec=pv.getMainSectionEl(); return sec && sec.querySelector('variant-picker'); };
    pv.getHandle = function(){
      var vp = pv.getVariantPicker();
      if (vp && vp.getAttribute('handle')) return vp.getAttribute('handle');
      var m = location.pathname.match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : null;
    };

    pv.getSelectedSize = function(){
      var sec = pv.getMainSectionEl(); if(!sec) return null;
      var sets = sec.querySelectorAll('fieldset.variant-picker__option, .variant-picker__option');
      for (var i=0;i<sets.length;i++){
        var fs = sets[i];
        var legend = fs.querySelector('legend, .variant-picker__option-info legend');
        var label = (legend && legend.textContent || '').trim().toLowerCase();
        if (label === 'size') {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked && checked.value) return checked.value;
        }
      }
      var any = sec.querySelector('input[type="radio"][name^="option"]:checked');
      return any ? any.value : null;
    };

    pv.getSelectedOptions = function(){
      var sec = pv.getMainSectionEl(); if(!sec) return [];
      var out = []; var i = 1, input;
      while ((input = sec.querySelector('input[type="radio"][name="option'+i+'"]:checked'))) {
        out.push(input.value);
        i++;
      }
      return out;
    };

    pv.selectVariantByOptions = function(options){
      var sec = pv.getMainSectionEl(); if (!sec) return;
      for (var i = 0; i < options.length; i++) {
        var val = options[i];
        var input = sec.querySelector('input[type="radio"][name="option' + (i+1) + '"][value="' + CSS.escape(val) + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(function(){ pv.ensureCorrectVariantIdSync() || pv.ensureCorrectVariantIdAsync(); }, 0);
    };

    pv.setAtcStateFromVariant = function(variant){
      var sec = pv.getMainSectionEl(); if (!sec || !variant) return;
      var btn = sec.querySelector('form.shopify-product-form button[type="submit"]');
      if (!btn) return;
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-text-atc') || 'Add to Cart';
      } else {
        btn.disabled = true;
        if (!btn.hasAttribute('data-text-atc')) btn.setAttribute('data-text-atc', btn.textContent.trim());
        btn.textContent = 'Sold out';
      }
    };

    // Product JSON helpers using shared cache
    pv.prefetchProductJsonForHandle = function(handle){
      return fetchProduct(handle);
    };
    pv.getVariantIdFromOptions = function(handle, selectedOptions){
      var json = productCache[handle];
      if (!json || !Array.isArray(json.variants)) return null;
      return (json.variants.find(function(v){
        if (!v || !Array.isArray(v.options)) return false;
        for (var i=0;i<selectedOptions.length;i++){
          if ((v.options[i] || '') !== (selectedOptions[i] || '')) return false;
        }
        return true;
      }) || {}).id || null;
    };
    pv.getProductJsonCurrent = function(){
      var h = pv.getHandle();
      return h ? productCache[h] || null : null;
    };
    pv.getSizeOptionIndex = function(json){
      if (!json || !Array.isArray(json.options)) return 0;
      var idx = json.options.findIndex(function(n){ return String(n || '').toLowerCase() === 'size'; });
      return idx === -1 ? 0 : idx;
    };

    pv.forceHiddenInputToVariant = function(variantId){
      var sec = pv.getMainSectionEl(); if (!sec || !variantId) return;
      sec.querySelectorAll('form.shopify-product-form input[name="id"]').forEach(function(input){
        if (String(input.value) !== String(variantId)) input.value = variantId;
      });
    };
    pv.getCurrentVariantIdFromHidden = function(){
      var sec = pv.getMainSectionEl(); if (!sec) return null;
      var input = sec.querySelector('form.shopify-product-form input[name="id"]');
      return input && input.value ? input.value : null;
    };
    pv.updateUrlWithVariant = function(variantId){
      if (!variantId) return;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variantId);
      history.replaceState(Object.assign({}, history.state || {}, {variantId:variantId, ajaxProduct:true}), '', u.pathname + u.search);
    };
    pv.ensureCorrectVariantIdSync = function(){
      var handle = pv.getHandle();
      var opts = pv.getSelectedOptions();
      if (!handle || !opts.length) return null;
      var vid = pv.getVariantIdFromOptions(handle, opts);
      if (vid) {
        pv.forceHiddenInputToVariant(vid);
        pv.updateUrlWithVariant(vid);
      }
      return vid;
    };
    pv.ensureCorrectVariantIdAsync = async function(){
      var handle = pv.getHandle();
      var opts = pv.getSelectedOptions();
      if (!handle || !opts.length) return null;
      await pv.prefetchProductJsonForHandle(handle);
      var vid = pv.getVariantIdFromOptions(handle, opts);
      if (vid) {
        pv.forceHiddenInputToVariant(vid);
        pv.updateUrlWithVariant(vid);
      }
      return vid;
    };
    pv.afterVariantSynced = function(cb){
      var vid = pv.ensureCorrectVariantIdSync();
      if (vid) { cb(vid); return; }
      pv.ensureCorrectVariantIdAsync().then(function(vid2){ cb(vid2); });
    };

    pv.invalidateWairPopup = function(){
      document.querySelectorAll('.wair-modal, .wair-widget-modal, [data-wair-modal], .wair-overlay, iframe[src*="wair"]').forEach(function(node){
        if (node.closest('[data-wair-preserve]')) return;
        node.remove();
      });
    };
    pv.refreshWairButton = function(){
      var wrap = document.querySelector('[data-wair-preserve]');
      if (!wrap) return;
      var btn = wrap.querySelector('button, a, [role="button"]');
      if (!btn) return;
      var vid = pv.getCurrentVariantIdFromHidden();
      if (vid) {
        wrap.setAttribute('data-variant-id', vid);
        btn.setAttribute('data-variant-id', vid);
      }
      var tick = String(Date.now());
      wrap.setAttribute('data-wair-tick', tick);
      btn.setAttribute('data-wair-tick', tick);
    };
    pv.notifyWair = function(){
      try {
        if (window.WAIR && typeof window.WAIR.refresh === 'function') window.WAIR.refresh();
        else document.dispatchEvent(new Event('wair:refresh'));
      } catch(e){}
    };

    pv.normalizePreservedAccordions = function(root){
      root.querySelectorAll('details[is="accordion-disclosure"]').forEach(function(d){
        d.classList.remove('auto-open');
        d.style.height = null; d.style.overflow = null;
        d.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
        var c = d.querySelector(':scope > .accordion__content');
        if (c) { c.style.opacity = null; c.style.transform = null; }
      });
    };
    pv.getVideoCellSrc = function(cell) {
      var source = cell.querySelector('video source');
      if (source && source.src) return source.src;
      var video = cell.querySelector('video');
      return (video && video.src) || '';
    };
    pv.replaceSectionHtml = function(sectionId, html, skipPreserve){
      var current = document.querySelector('#shopify-section-' + sectionId);
      if (!current) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var incoming = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incoming) return;

      if (skipPreserve) {
        // Option link swap: update accordion content in-place, then swap everything else
        // 1. Patch accordion inner content from incoming into current (no DOM removal)
        var curAccordions = current.querySelectorAll('.accordion-group[data-preserve] details[is="accordion-disclosure"]');
        var newAccordions = incoming.querySelectorAll('.accordion-group[data-preserve] details[is="accordion-disclosure"]');
        for (var i = 0; i < Math.min(curAccordions.length, newAccordions.length); i++) {
          var curContent = curAccordions[i].querySelector('.accordion__content');
          var newContent = newAccordions[i].querySelector('.accordion__content');
          if (curContent && newContent) {
            curContent.innerHTML = newContent.innerHTML;
          }
        }

        // 2. Now preserve the (already-updated) accordion groups during the swap
        if (current.classList.contains(PRODUCT_SECTION_CLASS)) {
          ['.accordion-group[data-preserve]','[data-wair-preserve]'].forEach(function (sel) {
            var oldList = current.querySelectorAll(sel);
            var newList = incoming.querySelectorAll(sel);
            for (var j = 0; j < newList.length; j++) {
              var keep = oldList[j], target = newList[j];
              if (keep && target) {
                target.replaceWith(keep);
              }
            }
          });

          /* ---- Preserve live <video> elements if the source file is the same ---- */
          var oldVidCells2 = current.querySelectorAll('.product-gallery__media[data-media-type="video"]');
          var newVidCells2 = incoming.querySelectorAll('.product-gallery__media[data-media-type="video"]');
          newVidCells2.forEach(function (newCell) {
            var newMediaId = newCell.getAttribute('data-media-id');
            var oldCell = null;
            oldVidCells2.forEach(function (c) {
              if (c.getAttribute('data-media-id') === newMediaId) oldCell = c;
            });
            if (!oldCell) return;
            var oldSrc = pv.getVideoCellSrc(oldCell);
            var newSrc = pv.getVideoCellSrc(newCell);
            if (oldSrc && newSrc && oldSrc === newSrc) {
              newCell.replaceWith(oldCell);
            }
          });
        }
        current.replaceWith(incoming);
      } else {
        // Color swatch swap: patch accordion content, then preserve groups
        if (current.classList.contains(PRODUCT_SECTION_CLASS)) {
          var curAccs = current.querySelectorAll('.accordion-group[data-preserve] details[is="accordion-disclosure"]');
          var newAccs = incoming.querySelectorAll('.accordion-group[data-preserve] details[is="accordion-disclosure"]');
          for (var i = 0; i < Math.min(curAccs.length, newAccs.length); i++) {
            var curC = curAccs[i].querySelector('.accordion__content');
            var newC = newAccs[i].querySelector('.accordion__content');
            if (curC && newC) {
              curC.innerHTML = newC.innerHTML;
            }
          }

          ['.accordion-group[data-preserve]','[data-wair-preserve]'].forEach(function (sel) {
            var oldList = current.querySelectorAll(sel);
            var newList = incoming.querySelectorAll(sel);
            for (var i = 0; i < newList.length; i++) {
              var keep = oldList[i], target = newList[i];
              if (keep && target) {
                pv.normalizePreservedAccordions(keep);
                target.replaceWith(keep);
              }
            }
          });

          /* ---- Preserve live <video> elements if the source file is the same ---- */
          var oldVidCells = current.querySelectorAll('.product-gallery__media[data-media-type="video"]');
          var newVidCells = incoming.querySelectorAll('.product-gallery__media[data-media-type="video"]');
          newVidCells.forEach(function (newCell) {
            var newMediaId = newCell.getAttribute('data-media-id');
            var oldCell = null;
            oldVidCells.forEach(function (c) {
              if (c.getAttribute('data-media-id') === newMediaId) oldCell = c;
            });
            if (!oldCell) return;
            var oldSrc = pv.getVideoCellSrc(oldCell);
            var newSrc = pv.getVideoCellSrc(newCell);
            if (oldSrc && newSrc && oldSrc === newSrc) {
              newCell.replaceWith(oldCell);
            }
          });
        }
        current.replaceWith(incoming);
      }
    };
    pv.replaceSectionImagesOnly = function(sectionId, html){
      var currentRoot = document.querySelector('#shopify-section-' + sectionId);
      if (!currentRoot) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var incomingRoot = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incomingRoot) return;

      var inImgs  = incomingRoot.querySelectorAll('img.detail--img');
      var curImgs = currentRoot.querySelectorAll('img.detail--img');
      var count = Math.min(inImgs.length, curImgs.length);
      for (var i=0;i<count;i++){
        var src = inImgs[i], dst = curImgs[i];
        ['data-src','data-srcset','data-sizes','data-widths','data-optimumx','alt'].forEach(function (name) {
          var val = src.getAttribute(name);
          if (val !== null) dst.setAttribute(name, val); else dst.removeAttribute(name);
        });
        dst.removeAttribute('src'); dst.removeAttribute('srcset');
        dst.classList.add('lazyload','lazyautosizes','Image--lazyLoad');
        dst.classList.remove('is-loaded','Image--lazyLoaded');
        if (window.lazySizes && lazySizes.loader) {
          lazySizes.loader.unveil(dst);
        }
      }
    };

    pv.hydrateLazyImgs = function(root){
      if (!root) return;
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.getAttribute('src') && img.dataset && img.dataset.src && img.dataset.src.indexOf('{width}') === -1) {
          img.setAttribute('src', img.dataset.src);
        }
        if (!img.getAttribute('srcset') && img.dataset && img.dataset.srcset && img.dataset.srcset.indexOf('{width}') === -1) {
          img.setAttribute('srcset', img.dataset.srcset);
        }
        if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
        img.addEventListener('load', function(){ img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function(){ img.classList.add('is-loaded'); }, { once: true });
      });
    };

    pv.reinitTheme = function(){
      var sec = pv.getMainSectionEl(); if (!sec) return;
      var id = sec.id.replace('shopify-section-','');

      try {
        document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: id } }));
        document.dispatchEvent(new CustomEvent('shopify:section:load',   { detail: { sectionId: id } }));
      } catch(e){}

      try {
        if (window.Prestige && typeof window.Prestige.init === 'function') window.Prestige.init();
        if (window.theme && typeof window.theme.initProduct === 'function') window.theme.initProduct(sec);
      } catch(e){}

      var pref = (typeof window.__preferredSizeOnce !== 'undefined' && window.__preferredSizeOnce) ? window.__preferredSizeOnce : pv.getSelectedSize();
      window.__preferredSizeOnce = null;
      if (pref) {
        var json = pv.getProductJsonCurrent();
        if (json) {
          var current = pv.getSelectedOptions();
          if (current.length) {
            var sizeIdx = pv.getSizeOptionIndex(json);
            var tryOptions = current.slice();
            tryOptions[sizeIdx] = pref;
            pv.selectVariantByOptions(tryOptions);
          }
        }
      } else {
        pv.ensureCorrectVariantIdSync() || pv.ensureCorrectVariantIdAsync();
      }

      pv.afterVariantSynced(function(){
        pv.invalidateWairPopup();
        pv.refreshWairButton();
        pv.notifyWair();
      });

      try { window.dispatchEvent(new Event('resize')); } catch(e){}
      if (window.lazySizes && lazySizes.autoSizer && lazySizes.autoSizer.checkElems) lazySizes.autoSizer.checkElems();

      var g = sec.querySelector(GALLERY_SELECTOR);
      var lead = g && g.querySelector('.product-gallery__media.is-initial img, .product-gallery__media.is-active img');
      if (lead && lead.complete && lead.naturalWidth > 0) lead.classList.add('is-loaded');

      document.dispatchEvent(new Event('okendo:refresh'));
    };

    pv.getRefreshPlan = function(){
      var plan = [];
      var mainId = pv.getMainSectionId();
      if (mainId) plan.push({ id: mainId, mode: 'full' });
      document.querySelectorAll('[data-product-refresh-full]').forEach(function (el) {
        var id = pv.getWrapperSectionIdFor(el);
        if (id && !plan.some(function(p){return p.id===id;})) plan.push({ id: id, mode: 'full' });
      });
      document.querySelectorAll('[data-product-refresh-images]').forEach(function (el) {
        var id = pv.getWrapperSectionIdFor(el);
        if (id && !plan.some(function(p){return p.id===id;})) plan.push({ id: id, mode: 'images' });
      });
      return plan;
    };

    pv.refreshTo = function(url, skipPreserve){
      window.__preferredSizeOnce = pv.getSelectedSize();

      var handle = (url.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
      if (handle) fetchProduct(handle);

      var plan = pv.getRefreshPlan();
      if (!plan.length) { window.location.href = url; return; }

      var ids = plan.map(function(p){ return p.id; });
      var sectionsUrl = pv.urlWithSections(url, ids);

      pv.setLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r){ return r.json(); })
        .then(function (json){
          plan.forEach(function (p){
            var html = json[p.id]; if (!html) return;
            if (p.mode === 'images') pv.replaceSectionImagesOnly(p.id, html);
            else pv.replaceSectionHtml(p.id, html, !!skipPreserve);
          });

          history.replaceState({ ajaxProduct:true, sectionIds: ids }, '', url.pathname + url.search);

          pv.hydrateLazyImgs(document);
          pv.reinitTheme();
        })
        .catch(function(){ window.location.href = url; })
        .finally(function(){ pv.setLoading(false); });
    };

    // PDP-only listeners
    document.addEventListener('click', function onPdpClick(e){
      var a = e.target.closest('a');
      if (!a) return;
      if (!a.closest('.variant-picker__option-values')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;

      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;

      if (!a.closest('.' + PRODUCT_SECTION_CLASS)) return;

      e.preventDefault();
      var isOptionLink = !!a.closest('.product-option-links');
      pv.refreshTo(new URL(href, window.location.origin), isOptionLink);
    });

    window.addEventListener('popstate', function onPdpPopState(e){
      if (!e.state || !e.state.ajaxProduct) return;

      window.__preferredSizeOnce = pv.getSelectedSize();

      var plan = pv.getRefreshPlan();
      if (!plan.length) return;
      var ids = plan.map(function(p){ return p.id; });
      var sectionsUrl = pv.urlWithSections(window.location.href, ids);

      pv.setLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r){ return r.json(); })
        .then(function (json){
          plan.forEach(function (p){
            var html = json[p.id]; if (!html) return;
            if (p.mode === 'images') pv.replaceSectionImagesOnly(p.id, html);
            else pv.replaceSectionHtml(p.id, html);
          });
          pv.hydrateLazyImgs(document);
          pv.reinitTheme();
        })
        .finally(function(){ pv.setLoading(false); });
    });

    document.addEventListener('DOMContentLoaded', function(){
      var h = pv.getHandle(); if (h) fetchProduct(h);
      pv.hydrateLazyImgs(document);
      pv.reinitTheme();
    });
  }

  /* ===================== Collection product cards ===================== */
  (function initCollectionCards(){
    var PREFETCH = {
      enable: true,
      maxPerCard: 8,
      prefetchSecondary: true,
      viewportLookahead: 1.2,
      maxConcurrent: 4
    };

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-card-swatches]').forEach(function (root) {
        var more = root.querySelector('[data-swatch-more]');
        var selected = root.querySelector('a.color-swatch.is-selected, a.thumbnail-swatch.is-selected');
        if (more && selected) more.href = selected.href;
      });
    });

    var inflight = 0;
    var queue = [];

    function schedule(task){
      queue.push(task);
      drain();
    }
    function drain(){
      if (inflight >= PREFETCH.maxConcurrent || !queue.length) return;
      inflight++;
      var fn = queue.shift();
      var done = function(){ inflight--; drain(); };
      try { var p = fn(); if (p && p.then) p.finally(done); else done(); } catch(e){ done(); }
    }

    function withinPdp(el){ return !!el.closest('.shopify-section--main-product'); }
    function card(el){ return el.closest('product-card.product-card'); }
    function leadImg(c){ return c ? c.querySelector('img.product-card__image--primary') : null; }
    function hoverImg(c){ return c ? c.querySelector('img.product-card__image--secondary') : null; }
    function mediaLink(c){ return c ? c.querySelector('a.product-card__media') : null; }
    function titleLink(c){ return c ? c.querySelector('a.product-title') : null; }
    function colorLink(c){ return c ? c.querySelector('a.product-color') : null; }
    function priceListEl(c){ return c ? c.querySelector('price-list.price-list') : null; }
    function badgeListEl(c){ return c ? c.querySelector('badge-list.badge-list') : null; }
    function setImg(el, src){ if (!el || !src) return; el.removeAttribute('srcset'); el.src = src; }

    // Prefer label from swatch DOM; fallback to product JSON later
    function swatchLabel(a){
      var s = (a.getAttribute('aria-label') || '').trim();
      if (s) return s;
      var sr = a.querySelector('.sr-only');
      return sr ? sr.textContent.trim() : '';
    }

    function splitTitleAndColor(fullTitle) {
      var t = String(fullTitle || '').trim();
      var parts = t.split(' - ');
      return {
        base: (parts[0] || '').trim(),
        color: (parts.slice(1).join(' - ') || '').trim()
      };
    }

    function getCurrencyFormat() {
      var tv = window.themeVariables && window.themeVariables.settings;
      if (tv && tv.currencyCodeEnabled && tv.moneyWithCurrencyFormat) return tv.moneyWithCurrencyFormat;
      if (tv && tv.moneyFormat) return tv.moneyFormat;
      return (window.Shopify && Shopify.money_format) || '${{amount}}';
    }

    function formatMoneySafe(cents, format) {
      format = format || getCurrencyFormat();

      if (cents === null || typeof cents === 'undefined') return '';
      if (typeof cents === 'string') cents = cents.replace('.', '');
      cents = parseInt(cents, 10);
      if (isNaN(cents)) return '';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = (typeof precision === 'number') ? precision : 2;
        thousands = thousands || ',';
        decimal = decimal || '.';

        var num = (number / 100).toFixed(precision);
        var parts = num.split('.');
        var dollars = parts[0];
        var centsPart = parts[1] || '';

        dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return precision ? (dollars + decimal + centsPart) : dollars;
      }

      var placeholderMatch = format.match(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_space_separator|amount_no_decimals_with_space_separator|amount_with_apostrophe_separator)\s*\}\}/);
      var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

      var value = '';
      switch (placeholder) {
        case 'amount':
          value = formatWithDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2, ',', '.');
      }

      return placeholderMatch ? format.replace(placeholderMatch[0], value) : value;
    }

    function formatMoneyNoZerosSafe(cents) {
      var out = formatMoneySafe(cents, getCurrencyFormat());
      return String(out).replace(/(\d)[\.,]00(?!\d)/g, '$1');
    }

    function pickCardVariant(productJson) {
      var vs = (productJson && productJson.variants) ? productJson.variants.slice() : [];
      if (!vs.length) return null;
      vs.sort(function(a, b) { return (Number(a.price) || 0) - (Number(b.price) || 0); });
      return vs[0];
    }

    function updateCardTitleAndLinks(cardEl, href, productJson) {
      var tA = titleLink(cardEl);
      var cA = colorLink(cardEl);

      var tc = splitTitleAndColor(productJson && productJson.title);

      if (tA) {
        if (tc.base) tA.textContent = tc.base;
        tA.href = href;
      }

      if (cA) {
        if (tc.color) cA.textContent = tc.color;
        cA.href = href;
      } else if (tA) {
        if (tc.base && tc.color) tA.textContent = tc.base + ' - ' + tc.color;
      }

      var mA = mediaLink(cardEl);
      if (mA) mA.href = href;
    }

    function updateCardImages(cardEl, productJson) {
      var imgs = (productJson && productJson.images) ? productJson.images : [];
      var primary = imgs[0] || '';
      var secondary = imgs[1] || primary;

      // Photo swiper cards: rebuild the gallery track from the new colorway's
      // images instead of the legacy primary/secondary swap, then reset the
      // gallery to slide 1 (listeners re-query slides, no re-bind needed).
      var sizesAttr = cardSizes(cardEl);

      var track = cardEl.querySelector('[data-gallery-track]');
      if (track) {
        var slides = track.querySelectorAll('.product-gallery__media');
        if (slides.length && imgs.length) {
          var cls = slides[0].className.replace(/\bactive\b/, '').trim();
          var alt = (productJson && productJson.title) || slides[0].alt || '';
          var sizesFromSlide = slides[0].getAttribute('sizes') || sizesAttr;
          var frag = document.createDocumentFragment();
          imgs.slice(0, 5).forEach(function (src) {
            var im = document.createElement('img');
            im.className = cls;
            im.loading = 'lazy';
            im.alt = alt;
            applyCardSrc(im, src, sizesFromSlide);
            frag.appendChild(im);
          });
          track.innerHTML = '';
          track.appendChild(frag);
          if (window.__refreshProductCardGallery) window.__refreshProductCardGallery(cardEl);
          return { primary: primary, secondary: secondary };
        }
      }

      var lead = leadImg(cardEl);
      var hover = hoverImg(cardEl);

      if (lead && primary) {
        applyCardSrc(lead, primary, lead.getAttribute('sizes') || sizesAttr);
        if (productJson && productJson.title) lead.alt = productJson.title;
      }

      if (hover && secondary) {
        applyCardSrc(hover, secondary, hover.getAttribute('sizes') || sizesAttr);
        if (productJson && productJson.title) hover.alt = productJson.title;
      }

      return { primary: primary, secondary: secondary };
    }

    function ensureSalePriceEl(priceList) {
      var saleEl = priceList.querySelector('sale-price');
      if (saleEl) return saleEl;

      saleEl = document.createElement('sale-price');
      saleEl.className = 'Pricing h6';
      saleEl.innerHTML = '<span class="sr-only">Sale price</span>';
      priceList.appendChild(saleEl);
      return saleEl;
    }

    function updateCardPrice(cardEl, productJson) {
      var priceList = priceListEl(cardEl);
      if (!priceList) return;

      var v = pickCardVariant(productJson);
      if (!v) return;

      var price = Number(v.price) || 0;
      var compare = Number(v.compare_at_price) || 0;
      var onSale = compare > price;

      var saleEl = ensureSalePriceEl(priceList);
      saleEl.classList.toggle('text-on-sale', onSale);
      saleEl.classList.toggle('text-subdued', !onSale);

      var sr = saleEl.querySelector('.sr-only');
      saleEl.innerHTML = '';
      if (sr) saleEl.appendChild(sr);
      else {
        var s = document.createElement('span');
        s.className = 'sr-only';
        s.textContent = 'Sale price';
        saleEl.appendChild(s);
      }
      saleEl.insertAdjacentHTML('beforeend', formatMoneyNoZerosSafe(price));

      var compareEl = priceList.querySelector('compare-at-price');
      if (onSale) {
        if (!compareEl) {
          compareEl = document.createElement('compare-at-price');
          compareEl.className = 'Pricing h6 text-subdued line-through';
          priceList.appendChild(compareEl);
        }
        compareEl.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoneyNoZerosSafe(compare);
      } else {
        if (compareEl) compareEl.remove();
      }
    }

    // Badge hierarchy (per selected color/product JSON):
    // Sold out > Bestseller > Sale > New > Limited
    function updateCardBadges(cardEl, productJson) {
      var badgeList = badgeListEl(cardEl);
      if (!badgeList) return;

      var tags = (productJson && productJson.tags) ? productJson.tags : [];
      var available = !!(productJson && productJson.available);

      // wipe previous badges (keep any inline <style>)
      Array.from(badgeList.children).forEach(function(node){
        if (node.tagName && node.tagName.toLowerCase() === 'style') return;
        node.remove();
      });

      var hasBestSeller = tags.indexOf('bestseller-badge') > -1;
      var hasNew = tags.indexOf('new-badge') > -1;
      var hasLimited = tags.indexOf('limited25') > -1;

      var v = pickCardVariant(productJson);
      var price = v ? Number(v.price) || 0 : 0;
      var compare = v ? Number(v.compare_at_price) || 0 : 0;
      var isOnSale = available && compare > price;

      if (!available) {
        var soldEl = document.createElement('sold-out-badge');
        soldEl.className = 'badge badge--sold-out';
        soldEl.textContent = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.soldOutBadge) || 'Sold out';
        badgeList.appendChild(soldEl);
        return;
      }

      // Bestseller is now per-color only (no locking)
      if (hasBestSeller) {
        var bestEl = document.createElement('bestseller');
        bestEl.className = 'badge badge--bestseller';
        bestEl.textContent = 'Best Seller';
        badgeList.appendChild(bestEl);
        return;
      }

      /*

      if (isOnSale) {
        var saleBadge = document.createElement('on-sale-badge');
        saleBadge.className = 'badge badge--on-sale';

        var template = document.querySelector('on-sale-badge[discount-mode]');
        if (template) {
          var mode = template.getAttribute('discount-mode');
          if (mode) {
            saleBadge.setAttribute('discount-mode', mode);
            saleBadge.classList.add('badge--' + mode);
          }
        }

        if (saleBadge.hasAttribute('discount-mode') && window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.discountBadge) {
          var mode2 = saleBadge.getAttribute('discount-mode') || '';
          var savings = mode2 === 'percentage'
            ? (Math.round((compare - price) * 100 / compare) + '%')
            : formatMoneyNoZerosSafe(compare - price);

          saleBadge.innerHTML = String(window.themeVariables.strings.discountBadge).replace('@@', savings);
        } else {
          saleBadge.textContent = 'Sale';
        }

        badgeList.appendChild(saleBadge);
        return;
      }
      */

      if (hasNew) {
        var newEl = document.createElement('new-badge');
        newEl.className = 'badge badge--new';
        newEl.textContent = 'New';
        badgeList.appendChild(newEl);
        return;
      }

      if (hasLimited) {
        var limitedEl = document.createElement('limited-badge');
        limitedEl.className = 'badge badge--limited';
        limitedEl.textContent = 'Limited Edition';
        badgeList.appendChild(limitedEl);
      }
    }

    // Click: prevent nav, swap images, update label + price + badges + title links
    document.addEventListener('click', function(e){
      var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
      if (!a) return;
      if (withinPdp(a)) return;

      var c = card(a); if (!c) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

      var href = a.getAttribute('href');
      var group = a.closest('.variant-picker__color-swatches');
      var more = group && group.querySelector('[data-swatch-more]');
      if (more) more.setAttribute('href', href);

      var handle = handleFromHref(href);
      if (!handle) return;

      // Toggle selection UI
      var wrap = a.closest('.variant-picker__color-swatches');
      if (wrap) {
        wrap.querySelectorAll('a.color-swatch, a.thumbnail-swatch').forEach(function(n){ n.classList.remove('is-selected'); });
        a.classList.add('is-selected');
      }

      // Set color line immediately from swatch label
      var cA = colorLink(c);
      var label = swatchLabel(a);
      if (cA) {
        if (label) cA.textContent = label;
        cA.href = href;
      }

      // Cancel any in-flight for this card
      if (c.__swatchCtrl) try { c.__swatchCtrl.abort(); } catch(_){}
      var ctrl = new AbortController(); c.__swatchCtrl = ctrl;
      c.__swatchToken = (c.__swatchToken || 0) + 1; var token = c.__swatchToken;

      fetchProduct(handle, ctrl.signal)
        .then(function(j){
          if (!j || token !== c.__swatchToken) return;

          c.dataset.activeHandle = handle;
          c.setAttribute('handle', handle);

          updateCardTitleAndLinks(c, href, j);

          if (cA && label) cA.textContent = label;

          updateCardBadges(c, j);
          updateCardPrice(c, j);

          var imgs = updateCardImages(c, j);
          var sz = cardSizes(c);
          return Promise.allSettled([
            preload(imgs.primary, sz),
            PREFETCH.prefetchSecondary ? preload(imgs.secondary, sz) : Promise.resolve()
          ]);
        })
        .catch(function(){});
    }, true);

    // Keyboard a11y
    document.addEventListener('keydown', function(e){
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
      if (!a || withinPdp(a)) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      a.click();
    }, true);

    // Hover prefetch
    document.addEventListener('mouseover', function(e){
      var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
      if (!a || withinPdp(a)) return;
      var handle = handleFromHref(a.getAttribute('href')); if (!handle) return;
      var hoverSizes = cardSizes(card(a));

      schedule(function(){
        return fetchProduct(handle).then(function(j){
          if (!j) return;
          var imgs = j.images || [];
          var p = imgs[0] || '';
          var s = imgs[1] || p;
          var tasks = [];
          if (p) tasks.push(preload(p, hoverSizes));
          if (PREFETCH.prefetchSecondary && s) tasks.push(preload(s, hoverSizes));
          return Promise.allSettled(tasks);
        });
      });
    }, { passive: true });

    // Full-card preload: once the shopper engages a card's photo swiper, warm
    // the lead image of each colorway so a colorway hop is instant. Fired by
    // custom.js on first swipe/drag/arrow interaction.
    //
    // This used to warm every gallery image of every swatch at full original
    // resolution — on the worst card in the catalog that was 68 originals and
    // roughly 863 MB of decoded bitmap from a single touch, which is well past
    // what iOS will hand a tab. Lead image only, sized, and capped.
    var WARM_MAX_COLORWAYS = 12;

    window.__preloadCardColorways = function (cardEl) {
      if (!cardEl || cardEl.__allColorsPreloaded) return;
      cardEl.__allColorsPreloaded = true;

      // Current colorway: flip the lazy slides to eager so the browser pulls
      // the sized candidates it would fetch on swipe anyway.
      cardEl.querySelectorAll('[data-gallery-track] img').forEach(function (img) {
        try { img.loading = 'eager'; } catch (_) {}
      });

      var sizesAttr = cardSizes(cardEl);
      var wrap = cardEl.querySelector('[data-card-swatches]') || cardEl;
      var links = wrap.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');

      Array.prototype.slice.call(links, 0, WARM_MAX_COLORWAYS).forEach(function (a) {
        var h = handleFromHref(a.getAttribute('href'));
        if (!h) return;
        schedule(function () {
          return fetchProduct(h).then(function (j) {
            if (!j) return;
            var first = (j.images || [])[0];
            return first ? preload(first, sizesAttr) : null;
          });
        });
      });
    };

    // Viewport prefetch
    if ('IntersectionObserver' in window && PREFETCH.enable) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting && entry.intersectionRatio === 0) return;
          var c = entry.target;
          var wrap = c.querySelector('[data-card-swatches]') || c;
          var links = wrap.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
          var limit = Math.min(links.length, PREFETCH.maxPerCard);
          var viewSizes = cardSizes(c);

          for (var i=0;i<limit;i++){
            (function(a){
              var h = handleFromHref(a.getAttribute('href')); if (!h) return;
              schedule(function(){
                return fetchProduct(h).then(function(j){
                  if (!j) return;
                  var imgs = j.images || [];
                  var p = imgs[0] || '';
                  var s = imgs[1] || p;
                  return PREFETCH.prefetchSecondary
                    ? Promise.allSettled([preload(p, viewSizes), preload(s, viewSizes)])
                    : preload(p, viewSizes);
                });
              });
            })(links[i]);
          }

          io.unobserve(c);
        });
      }, { root: null, rootMargin: Math.round((PREFETCH.viewportLookahead - 1) * 100) + '% 0px', threshold: [0, 0.01] });

      document.querySelectorAll('product-card.product-card').forEach(function(pc){ io.observe(pc); });
    }

    // Dynamic swatch count
    (function initDynamicSwatchCount() {
      var MOBILE_BREAKPOINT = 650;

      function isMobile() { return window.innerWidth < MOBILE_BREAKPOINT; }

      // Three passes over every card so the browser lays out once, not once per
      // card: reset all rows (writes), measure all rows (reads), then hide the
      // overflow and set the +N counts (writes). Interleaving them per card forced
      // a full layout for every card on the page.
      function prepare(container) {
        var swatches = Array.from(container.querySelectorAll('a.color-swatch, a.thumbnail-swatch'));
        if (!swatches.length) return null;
        var moreBtn = container.querySelector('[data-swatch-more]');
        swatches.forEach(function(s) { s.style.display = ''; });
        if (moreBtn) moreBtn.style.display = '';
        return {
          swatches: swatches,
          moreBtn: moreBtn,
          total: parseInt(container.getAttribute('data-total-colors')) || swatches.length,
          maxMobile: parseInt(container.getAttribute('data-max-mobile')) || 5,
          maxDesktop: parseInt(container.getAttribute('data-max-desktop')) || 9
        };
      }

      function measure(job, mobile) {
        var swatches = job.swatches;
        if (mobile) return Math.min(swatches.length, job.maxMobile);
        var firstRowTop = swatches[0].offsetTop;
        for (var k = 0; k < swatches.length; k++) {
          if (swatches[k].offsetTop !== firstRowTop || k >= job.maxDesktop) return k;
        }
        return swatches.length;
      }

      function apply(job) {
        for (var i = job.visible; i < job.swatches.length; i++) job.swatches[i].style.display = 'none';
        if (!job.moreBtn) return;
        var remaining = job.total - job.visible;
        if (remaining > 0) {
          job.moreBtn.style.display = '';
          var countSpan = job.moreBtn.querySelector('[data-remaining-count]');
          if (countSpan) countSpan.textContent = remaining;
        } else {
          job.moreBtn.style.display = 'none';
        }
      }

      function updateAllCards() {
        var mobile = isMobile();
        var jobs = [];
        document.querySelectorAll('.variant-picker__color-swatches').forEach(function(container) {
          var job = prepare(container);
          if (job) jobs.push(job);
        });
        jobs.forEach(function(job) { job.visible = measure(job, mobile); });
        jobs.forEach(apply);
      }

      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(updateAllCards, 300);
      });

      // Width only: iOS fires resize as the URL bar shows and hides on scroll.
      var resizeTimer;
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function() {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateAllCards, 100);
      });
    })();

    // Auto-swap sold out cards to next available color (wraps)
    function isCardSoldOut(c) {
      return !!c.querySelector('sold-out-badge, .badge--sold-out');
    }

    function getCardSwatches(c) {
      return Array.from(
        c.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch')
      ).filter(function(a){
        if (!a || !a.getAttribute('href')) return false;
        if (a.hasAttribute('data-swatch-more')) return false;
        return true;
      });
    }

    function findNextAvailableSwatch(swatches, startIndex) {
      if (!swatches || !swatches.length) return null;

      for (var step = 1; step <= swatches.length; step++) {
        var idx = (startIndex + step) % swatches.length;
        var cand = swatches[idx];
        if (!cand.classList.contains('sold_out')) return cand;
      }
      return null;
    }

    function autoSwapSoldOutCard(c) {
      if (!c || c.__autoSwappedOnce) return;
      if (!isCardSoldOut(c)) return;

      var swatches = getCardSwatches(c);
      if (swatches.length < 2) return;

      var selected = swatches.find(function(a){ return a.classList.contains('is-selected'); }) || swatches[0];
      var startIndex = Math.max(0, swatches.indexOf(selected));

      var next = findNextAvailableSwatch(swatches, startIndex);
      if (!next || next === selected) return;

      c.__autoSwappedOnce = true;
      next.click();
    }

    (function initAutoSwapSoldOutCards(){
      function observeCard(pc) {
        if (!pc || pc.__autoSwapObserved) return;
        pc.__autoSwapObserved = true;
        io2.observe(pc);
      }

      var io2 = ('IntersectionObserver' in window)
        ? new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if (!entry.isIntersecting) return;
              var pc = entry.target;
              io2.unobserve(pc);
              autoSwapSoldOutCard(pc);
            });
          }, { root: null, rootMargin: '60% 0px', threshold: 0.01 })
        : null;

      if (!io2) {
        document.querySelectorAll('product-card.product-card').forEach(function(pc){ autoSwapSoldOutCard(pc); });
        return;
      }

      document.querySelectorAll('product-card.product-card').forEach(observeCard);

      var mo = new MutationObserver(function(muts){
        muts.forEach(function(m){
          Array.from(m.addedNodes || []).forEach(function(n){
            if (!n || n.nodeType !== 1) return;
            if (n.matches && n.matches('product-card.product-card')) observeCard(n);
            if (n.querySelectorAll) n.querySelectorAll('product-card.product-card').forEach(observeCard);
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    })();

  })();
})();

